<template>
  <div>

    <div>
      <div class="place-info-wrapper" v-if="branchData.hours">
        <div class="icon-hours"></div>
        <div class="place-info" v-for="openHour in branchData.hours">{{openHour}}</div>
      </div>
      <!-- <div class="place-info-wrapper">
        <div class="icon-address"></div>
        <div class="place-info">{{branchData.address.administrative_area_level_1}}<br />{{branchData.address.route}} {{branchData.address.street_number}}</div>
        <div class="place-info" v-if="branchData.info">{{branchData.info}}</div>
      </div> -->
      <!-- <div class="place-info-map">

        <GoogleMapLoader :mapConfig="mapConfig">
          <template slot-scope="{ google, map }">
            <GoogleMapMarker
              v-for="marker in markers"
              :key="marker.id"
              :marker="marker"
              :google="google"
              :map="map"/>
          </template>
        </GoogleMapLoader>

      </div> -->
    </div>

  </div>
</template>

<script>
import Cart from '@/cart';

import Axios from 'axios'

// import GoogleMapLoader from '@/components/common/GoogleMapLoader'
// import GoogleMapMarker from '@/components/common/GoogleMapMarker'

export default {
  // name: 'branch-info-panel',
  props: ['branch'],
  components: {
    // GoogleMapLoader,
    // GoogleMapMarker
  },
  data() {
    return {
      branchData: this.branch.data,
      markers: {
        position: {
          lat: this.branch.data.address.latitude,
          lng: this.branch.data.address.longitude
        }
      },
      mapConfig: {
        zoom: 16,
        styles: ['satellite'],
        center: {
          lat: this.branch.data.address.latitude,
          lng: this.branch.data.address.longitude
        }
      }
    }
  },
  created() {
    console.log('BranchInfoPanel::created', this.branchData, this.markers)
    this.loadMap()
  },
  methods: {
    loadMap() {
      // if (this.branchData.maspSrc === undefined) {
      //   console.log('Loading map', this.branch)
      //   // get the map coordinates
      //   let address = this.branchData.address.city + ' ' + this.branchData.address.street + ' ' + this.branchData.address.number
      //   address = address.replace(/\W/g, '+')
      //   console.log(address)
      //   Axios.get('https://maps.googleapis.com/maps/api/geocode/json?address='+address+'&key=AIzaSyDSjFaXZR2D1VxgxYGhLzv5-fU7nbDYZBE')
      //   .then(gResponse => {
      //     console.log(gResponse)
      //     if (gResponse.data.results && gResponse.data.results.length > 0) {
      //       let mapSrc = 'https://www.google.com/maps/embed/v1/view?zoom=17&center='+
      //         gResponse.data.results[0].geometry.location.lat+'%2C'+
      //         gResponse.data.results[0].geometry.location.lng
      // 
      //       this.branchData.mapSrc = mapSrc
      //       console.log('Branch data', this.branchData)
      //     }
      //   })
      // }
    },
  }
}
</script>

<style scoped>
</style>
